/* RESPONSIBLE TEAM: team-ai-insights */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';

export default class FinAIAgentAnalyzeAIInsightsRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel() {
    if (this.appService.app.canSeeAiTopics) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.performance');
    }
  }

  get titleToken() {
    return this.intl.t('ai-agent.analyze.ai-insights');
  }
}
